import { IonPage } from '@ionic/react'

import { UnauthorizedCard } from '@apps-common/components/common'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'

import { TasksView } from './components'

export const UnitProgramTasksPage: React.FC = () => {
  const { navigateForward } = useNavigation()

  return (
    <IonPage>
      <Authorization
        roles={AUTH_CLAIMS.managementAdmin.roles}
        scopes={AUTH_CLAIMS.managementAdmin.scopes}
        notAuthorizedFallback={<UnauthorizedCard />}
      >
        <TasksView />
      </Authorization>
    </IonPage>
  )
}
